import styles from "./Leaderboard.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import classNames from "classnames";
import ClickableLink from "../../utilities/ClickableLink";
import { useStores } from "../../../stores/useStores";
import { Suspense, use } from "react";
import { IView } from "../../../stores/InterfaceStore";
import { LeaderboardEntry } from "../SchoolFeedDisplay";

function LeaderboardMembersList(props: { dataPromise: Promise<any> }) {
  const data = use(props.dataPromise);

  return (
    <ol>
      {data.map((d, idx) => {
        const itemClassName = classNames({
          [styles.item]: true,
          [styles.itemIsMe]: d["me"],
        });
        return (
          <li key={idx} className={itemClassName}>
            {d.rank} - {d.name}
          </li>
        );
      })}
    </ol>
  );
}

export default function Leaderboard(props: {
  leaderboardDataPromise: Promise<LeaderboardEntry[]>;
}) {
  const { interfaceStore } = useStores();

  return (
    <div className={styles.container}>
      <div>
        <h3>DISCUSSION LEADERBOARD</h3>
        {interfaceStore.view !== IView.LEADERBOARD && (
          <ClickableLink href={"/leaderboard"}>
            Learn More{" "}
            <FontAwesome prefix={"far"} name={"fa-question-circle"} />
          </ClickableLink>
        )}
      </div>
      <Suspense>
        <LeaderboardMembersList dataPromise={props.leaderboardDataPromise} />
      </Suspense>
    </div>
  );
}
